import { render, staticRenderFns } from "./FloatInput.vue?vue&type=template&id=6b2a07e8"
import script from "./FloatInput.vue?vue&type=script&lang=js"
export * from "./FloatInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports